/* eslint-disable no-useless-escape */
import jwtDecode from 'jwt-decode';
import { AVATAR_COLOR_GROUP } from 'Constants/webchat';
import humps from 'humps';
import axios from 'axios';
import moment from 'moment';
import BigNumber from 'bignumber.js';
import { nricFormatRegex } from 'Constants/appointment';

export const parseUserToken = () => {
  let token = {};

  try {
    const userToken = JSON.parse(localStorage.getItem('manadr:user.token'));
    token = humps.camelizeKeys(jwtDecode(userToken.token));
  } catch (error) {
    console.log(error); // eslint-disable-line no-console
  }

  return token;
};

export const roundWithTaxPercent = (price, tax) =>
  +new BigNumber(price).multipliedBy(1 + tax / 100).decimalPlaces(2);

export const extractRangeValue = str => {
  if (str) {
    const rangePattern =
      /^( {0,}\(? {0,})([0-9]*[.]?[0-9]+)( {0,}- {0,})([0-9]*[.]?[0-9]+)( {0,}\) {0,})?(.*)$/;
    const gte = /^( {0,}\(? {0,}(>=?) {0,})([0-9]*[.]?[0-9]+)( {0,}\) {0,})(.*)$/;
    const lte = /^( {0,}\(? {0,}(<=?) {0,})([0-9]*[.]?[0-9]+)( {0,}\) {0,})(.*)$/;

    let r;
    if (str.match(rangePattern)) {
      r = str.match(rangePattern);
      return {
        lower: {
          operator: '>=',
          value: +r[2],
        },
        upper: {
          operator: '<=',
          value: +r[4],
        },
      };
    }
    if (str.match(gte)) {
      r = str.match(gte);
      return {
        lower: {
          operator: r[2],
          value: +r[3],
        },
        upper: null,
      };
    }
    if (str.match(lte)) {
      r = str.match(lte);
      return {
        lower: null,
        upper: {
          operator: r[2],
          value: +r[3],
        },
      };
    }
    return null;
  }
  return null;
};

export const matchRange = (value, range) => {
  const { lower, upper } = typeof range === 'string' ? extractRangeValue(range) : range;
  if (lower && upper) {
    return {
      value: value >= lower.value && value <= upper.value,
      operator: 'in',
    };
  }
  if (lower) {
    return {
      value: lower.operator === '>=' ? value >= lower.value : value > lower.value,
      operator: 'lower',
    };
  }
  if (upper) {
    return {
      value: upper.operator === '<=' ? value <= upper.value : value < upper.value,
      operator: 'upper',
    };
  }
  return false;
};

export const extractYoutubeId = (link = '') => {
  const rx =
    /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
  const r = link.match(rx);
  return (r && r[1]) || null;
};

export const removeFalsy = obj => {
  const newObj = {};
  Object.keys(obj).forEach(prop => {
    if (
      typeof obj[prop] !== 'undefined' &&
      obj[prop] !== null &&
      obj[prop] !== '' &&
      obj[prop] !== '-'
    ) {
      newObj[prop] = obj[prop];
    }
  });
  return newObj;
};

class FileMemoryStorageClass {
  constructor() {
    this.files = {};
  }

  store(key, file) {
    this.files[key] = file;
  }

  get(key) {
    return this.files[key];
  }

  clearAll() {
    this.files = {};
  }

  clear(...params) {
    params.forEach(element => {
      delete this.files[element];
    });
  }
}

export const FileMemoryStorage = new FileMemoryStorageClass();

const downloadUri = (uri, name) => {
  const link = document.createElement('a');
  link.style.display = 'none';
  link.download = name;
  const blob = new Blob([uri], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  link.href = url;
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};

export const downloadFile = async (url, token, name = 'file.pdf') => {
  const response = await axios.get(url, {
    headers: { Authorization: token, Accept: 'application/pdf' },
    responseType: 'arraybuffer',
  });
  downloadUri(response.data, name);
};

const shift = (number, precision, reverseShift) => {
  let newPrecision = precision;
  if (reverseShift) {
    newPrecision = -precision;
  }
  const numArray = `${number}`.split('e');
  return +`${numArray[0]}e${numArray[1] ? +numArray[1] + newPrecision : newPrecision}`;
};

export const round = (number, precision) =>
  shift(Math.round(shift(number, precision, false)), precision, true);

export const findItemInList = (list, item, attribute = 'id') =>
  list.find(i => i[attribute] === item[attribute]);
export const hasItemInList = (list, item, attribute = 'id') =>
  !!list.find(i => i[attribute] === item[attribute]);

export const findItemInListByAttribute = (list, valueAttribute, attribute = 'id') =>
  list.find(i => i[attribute] === valueAttribute);

export const findRestList = (list, selectedList, attribute = 'id') =>
  list.filter(i => !selectedList.find(item => item[attribute] === i[attribute]));
export const fetchSettings = () => {
  if (window.globalSettings) {
    return window.globalSettings;
  }

  const json = localStorage.getItem('manadr:settings');
  window.globalSettings = json ? JSON.parse(atob(json)) : null;
  return window.globalSettings;
};

// ultil about time
export const isSameDate = (preTime, nextTime) => moment(preTime).isSame(moment(nextTime), 'day');

export const formatDate = date => moment(date).format('DD MMM YYYY');
export const haveItemInArrayByKey = (list, item, key) => list.some(i => item[key].includes(i[key]));

export const formatCurrencyNumber = (value = 0) =>
  value.toLocaleString('en', { maximumFractionDigits: 2 });

export const upcaseFirstLetter = string =>
  string && string.charAt(0).toUpperCase() + string.slice(1);

export const genOptionClinic = list =>
  list.map(({ id, name }) => ({
    key: id,
    value: id,
    text: name,
  }));

export const copyToClipboard = text => {
  if (window.clipboardData && window.clipboardData.setData) {
    // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
    return window.clipboardData.setData('Text', text);
  }
  if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
    const textarea = document.createElement('textarea');
    textarea.textContent = text;
    textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand('copy'); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn('Copy to clipboard failed.', ex);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }
  return text;
};

export const getColorComboByCharacter = letter => {
  const charCode = letter.toUpperCase().charCodeAt();
  const colorGroup = charCode % 10;
  return AVATAR_COLOR_GROUP[colorGroup];
};

export const getNextComboByCharacter = letter => {
  const charCode = letter.toUpperCase().charCodeAt();
  const colorGroup = (charCode + 1) % 10;
  return AVATAR_COLOR_GROUP[colorGroup];
};

export const generateIncludeParams = (obj, prefix, str = []) => {
  // eslint-disable-next-line no-var
  Object.keys(obj).forEach(objKey => {
    if (Object.hasOwn(obj, objKey)) {
      const k = prefix ? `${prefix}.${objKey}` : objKey;
      const v = obj[objKey];
      if (v !== null && typeof v === 'object') {
        generateIncludeParams(v, k, str);
      } else {
        str.push(`${encodeURIComponent(k)}`);
      }
    }
  });
  return str.join(',');
};

/**
 * Generates a formatted medicine instruction string based on the medicine details
 *
 * @param {Object} medicine - The medicine object containing instruction details
 * @param {boolean} isMedicineFromStorage - Flag indicating if medicine is from storage (e.g., OTTER or LIFEPACK)
 * @returns {string} Formatted instruction string for the medicine
 *
 * For custom instructions, returns the note directly
 * For non-storage medicines without dose/frequency info, returns empty string
 * For standard medicines, formats as "Take X units each time, frequency (note)"
 * For storage medicines, includes duration information if available
 */

export const genMedicineInstruction = (medicine, isMedicineFromStorage = false) => {
  const { amountPerTime, doseUnit, frequency, durationUnit, note, duration, useCustomInstruction } =
    medicine;
  if (!useCustomInstruction && !isMedicineFromStorage && !doseUnit && !frequency) {
    // this case for dr manual key in medicine => not have instruction
    return '';
  }
  if (useCustomInstruction) {
    return note;
  }
  if (!isMedicineFromStorage) {
    return `Take ${amountPerTime} ${doseUnit} each time, ${frequency} ${note && `(${note})`}`;
  }

  const durationText = duration && durationUnit ? `for ${duration} ${durationUnit}` : '';

  return `Take ${amountPerTime} ${doseUnit}, ${frequency} ${durationText.toLowerCase()} ${
    note && `(${note})`
  }`;
};

export const isOver16YearsOld = nric => {
  if (!nric || !nricFormatRegex.test(nric)) return true;
  const currentYear = new Date().getFullYear();
  const generationYear = nric?.charAt(0)?.toUpperCase() === 'T' ? 2000 : 1900;
  const birthYear = parseInt(nric.substring(1, 3), 10) + generationYear;
  const age = currentYear - birthYear;
  return age >= 16;
};
